import React from 'react';
import AboutUsPage from './AboutUsPage/AboutUsPage';

const AboutUs = () => {
    return (
        <div>
            <AboutUsPage />
        </div>
    );
};

export default AboutUs;
